import { render, staticRenderFns } from "./MovieRatingHistoryModal.vue?vue&type=template&id=018ec052&"
import script from "./MovieRatingHistoryModal.vue?vue&type=script&lang=js&"
export * from "./MovieRatingHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports